import {Component, OnInit} from '@angular/core';
import {DataStorageService} from './shared/services/data-storage.service';
import {AuthenticationService} from './authentication/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    constructor(private dataStorageService: DataStorageService, private authenticationService: AuthenticationService) {

    }

    ngOnInit(): void {

        this.authenticationService.autoLogin();

        this.dataStorageService.fetchDispatchGroups().subscribe();
        this.dataStorageService.fetchRouteGroups().subscribe();
        this.dataStorageService.fetchRoutes().subscribe();
        this.dataStorageService.fetchStops().subscribe();
        this.dataStorageService.fetchBlockedDate().subscribe();
        this.dataStorageService.fetchUserLists().subscribe();
        this.dataStorageService.fetchDiscount().subscribe();
        this.dataStorageService.fetchVehicles().subscribe();

    }

}
